var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon3 = function SvgIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    y: 0.5,
    fill: "#121214",
    rx: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.707 15.652-8.621-8.644 10.969 6.297zM9.836 6.5c-.508.266-.848.75-.848 1.379v17.238c0 .63.34 1.113.848 1.38l10.023-10zm16.61 8.813-2.302-1.333-2.566 2.52 2.567 2.52 2.347-1.332c.703-.56.703-1.817-.047-2.375m-14.36 10.68 10.969-6.298-2.348-2.347z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 6.5h20v20H8z"
  })))));
};
export default SvgIcon3;